var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4971_10137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.09968 3.33177L4.19683 4.19699L0.393677 2.29541V13.7049L4.19683 15.6065L7.99999 13.7049L12.1201 15.6065L15.6063 13.7049V2.29541L12.1201 4.19699L11.7033 4.14723",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8034 3.24592C11.8034 5.8327 8.951 9.26759 8.951 9.26759C8.951 9.26759 6.09863 5.89419 6.09863 3.24592C6.09863 1.67046 7.37554 0.393555 8.951 0.393555C10.5265 0.393555 11.8034 1.67046 11.8034 3.24592Z",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.95093 2.23438C8.60853 2.23438 8.28015 2.37039 8.03804 2.6125C7.79593 2.85462 7.65991 3.18299 7.65991 3.52539C7.65991 3.86779 7.79593 4.19616 8.03804 4.43828C8.28015 4.68039 8.60853 4.81641 8.95093 4.81641C9.29333 4.81641 9.6217 4.68039 9.86381 4.43828C10.1059 4.19616 10.2419 3.86779 10.2419 3.52539C10.2419 3.18299 10.1059 2.85462 9.86381 2.6125C9.6217 2.37039 9.29333 2.23438 8.95093 2.23438Z",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4971_10137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapOutline);
export default __webpack_public_path__ + "static/media/map-outline.508037a93f61398ea18f345442972fec.svg";
export { ForwardRef as ReactComponent };